import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import EventClientTabs from './Tabs';
import LandingPage from '../../LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';

function Events() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <>
      <LandingPage>
        <div className={`dash-board`}>
          <Card className={classes.cardStyling} elevation={0}>
            <div>
              <EventClientTabs />
            </div>
          </Card>
        </div>
      </LandingPage>
    </>
  );
}

export default Events;
